import styled from "styled-components";
import {
	Button as AntButton,
	Divider as AntDivider,
	Modal as AntModal,
} from "antd";

export const InviteLinkContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding: 32px;
`;

export const InviteLinkTitle = styled.p`
	color: ${(props) => props.theme.dark1};
	font-size: 18px;
	text-align: center;
	line-height: 28px;
	margin: 18px 0 18px;
	padding: 0px;
	/* padding-bottom: 32px; */
`;

export const InviteLinkTerm = styled.p`
	color: #71207c;
	font-size: 18px;
	text-align: center;
	line-height: 28px;
	margin: 0px;
	padding: 0px;
	padding-top: 80px;
	padding-bottom: 24px;
	font-weight: 600;
`;

export const InviteLinkTerms = styled.span`
	font-size: 14px;
	line-height: 28px;
	margin: 0px;
	padding: 0px;
	padding-bottom: 16px;
	color: ${(props) => props.theme.dark2};
`;

export const CopyTitle = styled.p`
	color: ${(props) => props.theme.primarySolid};
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 10px;
`;

export const CopyLink = styled.a`
	color: #858585;
	font-weight: 400;
	font-size: 14px;
	text-decoration: underline;
	display: block;
	margin-bottom: 20px;
	padding: 0 30px;
`;

export const Button = styled(AntButton)`
	width: 116px;
	height: 56px;
	border-radius: 12px;
	color: ${(props) => props.theme.textColor};
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin-bottom: 25px;
	background: ${(props) => props.theme.white} !important;
	:hover {
		background: ${(props) => props.theme.white} !important;
	}
`;

export const ButtonText = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const Divider = styled(AntDivider)`
	/* padding: 0px 30px 12px 30px; */
	.ant-divider-inner-text {
		font-size: 14px;
		font-weight: 400;
		color: ${(props) => props.theme.textColor};
		background: white;
		border-radius: 21px;
		padding: 4px 16px;
	}

	::before,
	::after {
		border: 1px solid ${(props) => props.theme.divider};
		border-color: ${(props) => props.theme.divider} !important;
	}
`;

export const FooterContainer = styled.div`
	height: 52px;
	display: flex;
	border-top: 2px solid #f4f1eb;
`;

export const CancelButton = styled.div`
	cursor: pointer;
	color: ${(props) => props.theme.dark1};
	font-size: 14px;
	font-weight: 600;
	line-height: 14px;
	width: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const CopyButton = styled.div`
	cursor: pointer;
	color: ${(props) => props.theme.blackGradient};
	font-size: 14px;
	font-weight: 600;
	line-height: 14px;
	width: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	background: ${(props) => props.theme.golden};
	border-radius: 0 0 8px 0;
`;

export const Modal = styled(AntModal)`
	.ant-modal-content {
		margin: 0;
		padding: 10px 0 0 0;
	}
`;
